import React from 'react';
import { Tab } from '@mui/material';
import { TabsWrapper } from 'src/style/common';
import { DetailProducts } from 'src/frontend-common/dto/Types/ProductType';

interface TabItem {
  label: React.ReactNode; // Può essere una stringa o un elemento JSX
  testId: string;
  product: DetailProducts;
  style?: React.CSSProperties;
  disabledForNonAdmin?: boolean;
}

interface ManualLookupsTabsProps {
  activeTab: number;
  handleTabChange: (_event: unknown, newValue: number, dontChangeDefault?: boolean) => void;
  isAdmin: boolean;
}

export const manualLookupsTabs: TabItem[] = [
  {
    label: 'Onboarding',
    testId: 'onboarding-tab',
    product: 'onboarding',
    style: { minWidth: 116 },
  },
  {
    label: 'Phone Number',
    testId: 'phone-tab',
    product: 'phone',
    style: { minWidth: 135 },
  },
  {
    label: 'Email Address',
    testId: 'email-tab',
    product: 'email',
    style: { minWidth: 135 },
  },
  {
    label: 'IP Address',
    testId: 'ip-tab',
    product: 'ip',
    style: { width: 110 },
  },
  {
    label: 'Domain',
    product: 'domain',
    testId: 'domain-tab',
  },
  {
    label: 'Login',
    testId: 'login-tab',
    product: 'login',
    style: { minWidth: 110 },
  },
];

const ManualLookupsTabs: React.FC<ManualLookupsTabsProps> = ({ activeTab, handleTabChange, isAdmin }) => {
  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  return (
    <TabsWrapper value={activeTab} indicatorColor="primary" onChange={handleTabChange} style={{ marginTop: 0 }}>
      {manualLookupsTabs.map((tab, index) => (
        <Tab
          key={index}
          label={tab.label}
          data-testid={tab.testId}
          {...a11yProps(index)}
          style={tab.style}
          disabled={tab.disabledForNonAdmin ? !isAdmin : false}
        />
      ))}
    </TabsWrapper>
  );
};

export default ManualLookupsTabs;
